export enum ScreenModes {
    EDIT,
    NEW,
    EDIT_LINK,
    NEW_VERSION
  }